<template>
    <div class="min-w-[500px] overflow-auto h-full">
        <div
            class="flex flex-wrap sm:flex-nowrap items-center justify-between my-4 lg:my-8"
        >
            <!-- title -->
            <div class="order-1 flex-grow flex items-center">
                <svg
                    viewBox="0 0 40 40"
                    class="block w-8 h-8 stroke-current text-navy"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <g
                        transform="matrix(1.6666666666666667,0,0,1.6666666666666667,0,0)"
                    >
                        <path
                            d="M15,19.5a3.75,3.75,0,0,1-7.5,0V.75H15Z"
                            fill="none"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="1"
                        ></path>
                        <path
                            d="M17.25 0.75L5.25 0.75"
                            fill="none"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="1"
                        ></path>
                        <path
                            d="M15 5.25L7.5 5.25"
                            fill="none"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="1"
                        ></path>
                    </g>
                </svg>

                <span class="ml-2 text-navy font-bold leading-7 text-2xl">
                    Soil Sample Results CSV Import
                </span>
            </div>

            <!-- Back to Tasks -->
            <div class="order-2 sm:order-3 sm:mr-3 mb-4">
                <inertia-link
                    class="flex items-center justify-center w-7 h-7 rounded-full bg-navy hover:bg-navy-dark focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-navy-light"
                    :href="route('app.task.index')"
                >
                    <svg
                        viewBox="0 0 40 40"
                        xmlns="http://www.w3.org/2000/svg"
                        class="block w-7 h-7 stroke-current text-white"
                    >
                        <g
                            transform="matrix(1.6666666666666667,0,0,1.6666666666666667,0,0)"
                        >
                            <path
                                d="M7.501 11.997L16.501 11.997"
                                fill="none"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="1.5"
                            ></path>
                            <path
                                d="M11.251 15.747L7.501 11.997 11.251 8.247"
                                fill="none"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="1.5"
                            ></path>
                        </g>
                    </svg>
                    <span class="sr-only"> Tasks </span>
                </inertia-link>
            </div>

            <div class="order-3">
                <a
                    :href="
                        route('app.soil-analysis.csv-import.download', 'sample')
                    "
                    class="flex flex-col items-center justify-center ml-2 mr-5"
                    target="_blank"
                >
                    <div
                        class="flex items-center justify-center w-7 h-7 rounded-full bg-navy hover:bg-navy-dark focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-navy-light"
                    >
                        <svg
                            viewBox="0 0 40 40"
                            xmlns="http://www.w3.org/2000/svg"
                            class="block w-4 h-4 stroke-current text-white"
                        >
                            <g
                                transform="matrix(1.6666666666666667,0,0,1.6666666666666667,0,0)"
                            >
                                <path
                                    d="M5.251,9.25,12,16l6.75-6.75H15V2.5a.75.75,0,0,0-.75-.75h-4.5A.75.75,0,0,0,9,2.5V9.25Z"
                                    fill="none"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-width="2"
                                ></path>
                                <path
                                    d="M23.251,17.5v3a1.5,1.5,0,0,1-1.5,1.5H2.251a1.5,1.5,0,0,1-1.5-1.5v-3"
                                    fill="none"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-width="2"
                                ></path>
                            </g>
                        </svg>
                    </div>
                    <div class="text-xs text-navy">Sample</div>
                </a>
            </div>

            <div class="order-4">
                <a
                    :href="
                        route('app.soil-analysis.csv-import.download', 'blank')
                    "
                    class="flex flex-col items-center justify-center"
                    target="_blank"
                >
                    <div
                        class="flex items-center justify-center w-7 h-7 rounded-full bg-navy hover:bg-navy-dark focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-navy-light"
                    >
                        <svg
                            viewBox="0 0 40 40"
                            xmlns="http://www.w3.org/2000/svg"
                            class="block w-4 h-4 stroke-current text-white"
                        >
                            <g
                                transform="matrix(1.6666666666666667,0,0,1.6666666666666667,0,0)"
                            >
                                <path
                                    d="M5.251,9.25,12,16l6.75-6.75H15V2.5a.75.75,0,0,0-.75-.75h-4.5A.75.75,0,0,0,9,2.5V9.25Z"
                                    fill="none"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-width="2"
                                ></path>
                                <path
                                    d="M23.251,17.5v3a1.5,1.5,0,0,1-1.5,1.5H2.251a1.5,1.5,0,0,1-1.5-1.5v-3"
                                    fill="none"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-width="2"
                                ></path>
                            </g>
                        </svg>
                    </div>
                    <div class="text-xs text-navy">Blank</div>
                </a>
            </div>
        </div>

        <flash-message />

        <div class="bg-white my-4 lg:my-8 lg:py-2">
            <form @submit.prevent="upload" enctype="multipart/form-data">
                <div class="lg:flex w-full">
                    <div class="p-2 lg:mx-4 lg:w-1/2">
                        <label
                            class="block text-sm font-medium text-gray-700"
                            for="file-format"
                        >
                            File format
                        </label>

                        <select
                            id="file-format"
                            class="mt-1 mb-3 text-sm rounded-md border-gray-300"
                            v-model="fileFormat"
                            @change="matchCsvHeader = false"
                        >
                            <option value="livefarm">LiveFarm template</option>
                            <option
                                v-for="format in labFormats"
                                :key="format.key"
                                :value="format.key"
                            >
                                {{ format.label }} results file
                            </option>
                        </select>

                        <label
                            class="block text-sm font-medium text-gray-700"
                            for="mobile"
                        >
                            Upload CSV Import
                        </label>

                        <input
                            id="mobile"
                            type="file"
                            accept=".csv"
                            v-on:change="changeFile"
                        />

                        <p
                            v-if="selectedLabFormat"
                            class="mt-2 text-xs text-gray-500"
                        >
                            Upload the {{ selectedLabFormat.label }} CSV file
                            unchanged. Every sample must be on a test sent to
                            {{ selectedLabFormat.label }}.
                        </p>

                        <p v-if="testFileAvailable" class="mt-2 text-xs">
                            <a
                                class="text-purple-600 underline"
                                :href="
                                    route(
                                        'app.soil-analysis.csv-import.test-file',
                                        fileFormat
                                    )
                                "
                            >
                                Download a test file
                            </a>
                            <span class="text-gray-500">
                                (made-up results for the latest task with
                                samples waiting for results; not shown in
                                production)
                            </span>
                        </p>
                    </div>

                    <div class="p-2 lg:mx-4 lg:w-1/2 text-right">
                        <br />
                        <button
                            type="submit"
                            class="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:border-gray-400 disabled:text-gray-400 disabled:bg-gray-200"
                            :disabled="file == null || foundDuplicated"
                        >
                            Upload file
                        </button>
                    </div>
                </div>
            </form>
        </div>

        <div class="p-4 mb-4 bg-yellow-100" v-if="awaitingConfirmation">
            <div class="font-bold">
                Is this the right
                {{ importTasks.length == 1 ? "task" : "set of tasks" }}?
            </div>

            <p class="my-2 text-sm">
                The samples in this file were found on the
                {{ importTasks.length == 1 ? "task" : "tasks" }} below. No
                results have been saved yet. A task changes to Complete once
                every sample on it has a result.
            </p>

            <csv-import-tasks :tasks="importTasks" />

            <div class="mt-3 flex justify-between">
                <a
                    class="inline-flex justify-center py-2 px-4 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                    :href="
                        route('app.soil-analysis.csv-import.cancel', download)
                    "
                >
                    Cancel the import
                </a>

                <button
                    type="button"
                    class="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:border-gray-400 disabled:text-gray-400 disabled:bg-gray-200"
                    :disabled="finishing"
                    @click="confirmUpload"
                >
                    Continue upload
                </button>
            </div>
        </div>

        <div
            class="p-4 mb-4 font-bold bg-green-100 w-full"
            v-if="matchCsvHeader"
        >
            Match Uploaded CSV Head to livefarm required data

            <div class="mt-3 w-full overflow-x-auto whitespace-nowrap py-3">
                <div class="inline-block">
                    <div
                        v-for="(header, index) in liveFarmRequiredFields"
                        :key="index"
                        class="p-2 block text-sm"
                    >
                        <div>{{ header }}</div>
                        <div class="mt-2">
                            <select
                                class="text-xs"
                                v-model="matchedHeader[index]"
                                @change="
                                    optionSelected($event.target.selectedIndex)
                                "
                            >
                                <option
                                    v-for="(option, i) in dropdownOptions"
                                    :key="i"
                                    :class="
                                        !option.selected ||
                                        option.value == 'none' ||
                                        (option.selected &&
                                            matchedHeader[index] ==
                                                option.value)
                                            ? 'block'
                                            : 'hidden'
                                    "
                                    :value="option.value"
                                    :selected="
                                        !(index in matchedHeader) &&
                                        option.value == 'none'
                                            ? true
                                            : false
                                    "
                                >
                                    {{ option.value }}
                                </option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>

            <div class="mt-3">
                <button
                    @click="submitMapColumns"
                    class="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:border-gray-400 disabled:text-gray-400 disabled:bg-gray-200"
                    :disabled="file == null"
                >
                    Upload Matched Header
                </button>
            </div>
        </div>

        <div
            class="p-4 mb-4 font-bold bg-red-100"
            v-if="error && errors != undefined && errors.file != undefined"
        >
            The file must be a CSV.
        </div>

        <div
            class="p-4 mb-4 font-bold bg-red-100"
            v-if="error && error_type == 'invalid'"
        >
            The CSV did not pass the validation.

            <div class="my-2" v-for="(error, key) in errors" :key="key">
                <span v-if="error.row != 'All rows'">Row {{ error.row }}:</span>

                <ul class="my-2 list-disc list-inside text-sm">
                    <li
                        v-for="(detail, detail_key) in error.errors"
                        :key="detail_key"
                    >
                        {{ detail }}
                    </li>
                </ul>
            </div>

            <div class="mt-4">
                <a
                    class="text-purple-600"
                    v-bind:href="
                        '/app/soil-analysis/csv-import/' +
                        download +
                        '/download'
                    "
                >
                    Click here to download your CSV file.
                </a>
                <div class="text-sm text-black">
                    Please review the errors above and upload the file again.
                </div>
            </div>
        </div>

        <div
            class="p-4 mb-2 font-bold bg-yellow-100"
            v-if="error && error_type == 'duplicated'"
        >
            Some results from the CSV were already matched to task records.
            <br />
            Check the rows that will override the existing matches and click on
            "Finish Import".

            <csv-import-tasks class="mt-2" :tasks="importTasks" />

            <form @submit.prevent="duplicated">
                <div class="mt-2" v-for="(error, key) in errors" :key="key">
                    <input
                        class="rounded border-gray-300 text-indigo-600 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
                        :id="'farm_' + key"
                        type="checkbox"
                        v-model="errors[key].duplicated"
                    />
                    <span class="ml-2 text-sm font-medium text-gray-600">
                        Row {{ error.csv_row }}
                    </span>
                </div>

                <div class="p-2 flex justify-between">
                    <a
                        class="inline-flex justify-center py-2 px-4 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                        :href="
                            route(
                                'app.soil-analysis.csv-import.cancel',
                                download
                            )
                        "
                    >
                        Cancel the import
                    </a>

                    <button
                        type="submit"
                        class="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:border-gray-400 disabled:text-gray-400 disabled:bg-gray-200"
                        :disabled="finishing"
                    >
                        Finish Import
                    </button>
                </div>
            </form>
        </div>


        <div
            class="p-4 mb-2 font-bold bg-red-100"
            v-if="error && error_type == 'sample_id_collusion'"
        >
            The following samples are associated with two or more tasks. Please ensure samples are associated with one task only and upload again
            <br />
            Samples:
            <ul class="my-2 list-disc list-inside text-sm">
                <li v-for="(error, key) in errors" :key="key">
                    Row {{ error.csv_row }}: {{ error.sample_id }}
                </li>
            </ul>

        </div>

        <div v-if="success" class="p-2 mb-4 bg-green-100 text-green-700">
            <div class="font-bold">The CSV Import has been successful</div>

            <csv-import-tasks
                v-if="importTasks.length > 0"
                class="mt-2"
                :tasks="importTasks"
                show-open
            />
        </div>

        <div v-if="uploads.length > 0">
            <div
                class="overflow-x-auto shadow border-b border-gray-200 sm:rounded-lg"
            >
                <div v-if="uploads.length > 0">
                    <table
                        class="table-auto min-w-full divide-y divide-gray-200"
                    >
                        <thead class="bg-gray-50">
                            <tr class="text-left font-bold">
                                <th
                                    scope="col"
                                    class="p-2 ptext-left text-xs text-gray-500 uppercase tracking-wider"
                                >
                                    Date
                                </th>
                                <th
                                    scope="col"
                                    class="p-2 ptext-left text-xs text-gray-500 uppercase tracking-wider"
                                >
                                    Status
                                </th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                v-for="(upload, index) in uploads"
                                :key="upload.id"
                                :class="
                                    index % 2 == 0 ? 'bg-white' : 'bg-gray-50'
                                "
                            >
                                <td
                                    class="p-2 whitespace-nowrap text-sm text-gray-500 font-bold"
                                >
                                    {{ upload.date }}
                                </td>
                                <td
                                    class="p-2 whitespace-nowrap text-sm text-gray-500"
                                >
                                    {{ upload.status }}
                                </td>
                                <td
                                    class="p-2 whitespace-nowrap text-sm text-gray-500"
                                >
                                    <a
                                        class="px-4 flex items-center text-blue-600"
                                        v-bind:href="upload.download"
                                    >
                                        Download
                                    </a>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <div class="flex items-center justify-center">
                <pagination class="mt-8 mb-4" :links="links" />
            </div>
        </div>

        <div
            v-if="uploads.length === 0"
            class="bg-white px-4 py-5 sm:rounded-lg sm:p-6"
        >
            <strong>No CSV Imports found.</strong>
        </div>
    </div>
</template>

<script>
import AppLayout from "@/Layouts/App";
import Pagination from "@/Components/Pagination";
import CsvImportTasks from "./Partials/CsvImportTasks.vue";
import _ from "lodash";
import FlashMessage from "@/Components/FlashMessage.vue";
import clickOutSide from "@mahdikhashan/vue3-click-outside";
import Multiselect from "@vueform/multiselect";
import Papa from "papaparse";
import { useToast } from "vue-toastification";

export default {
    layout: [AppLayout],
    components: {
        Pagination,
        CsvImportTasks,
        FlashMessage,
        Multiselect,
    },

    props: {
        role: String,
        results: Object,
        paginate: String,
        // Lab CSV formats: { key, label }
        labFormats: {
            type: Array,
            default: () => [],
        },
        testFileAvailable: {
            type: Boolean,
            default: false,
        },
    },

    directives: {
        clickOutSide,
    },

    data() {
        return {
            uploads: this.results["original"]["data"],
            links: this.results["original"]["meta"]["pagination"],
            link: this.paginate,

            matchCsvHeader: false,
            foundDuplicated: false,
            fileFormat: "livefarm",
            file: null,
            success: null,
            download: null,
            error: false,
            error_type: null,
            errors: [],
            // The tasks found wait for the user's OK before results are saved
            awaitingConfirmation: false,
            // The tasks of the import being finished or just finished
            importTasks: [],
            finishing: false,

            farmer: {
                search: "",
                chosen: "",
                open: false,
                farmers: {},
                farms: {},
                tasks: {},
            },
            dropdownOptions: [],
            matchedHeader: [],
            liveFarmBackendFields: [
                "sample_id",
                "ph_water",
                "ph_buffer",
                "potassium_k",
                "phosphorus_p",
                "organic_matter_om",
                "magnesium_mg",
                "calcium_ca",
                "copper_cu",
                "manganese_mn",
                "zinc_zn",
                "boron_b",
                "lab_ref_no",
                "lab_received_date",
                "result_date",
            ],
            liveFarmRequiredFields: [
                "Sample Id",
                "PH (Water)",
                "PH (Buffer)",
                "Potassium (K)",
                "Phosphorus (P)",
                "Organic Matter (OM)",
                "Magnesium (Mg)",
                "Calcium (Ca)",
                "Copper (Cu)",
                "Manganese (Mn)",
                "Zinc (Zn)",
                "Boron (B)",
                "Lab Ref No (optional)",
                "Lab Received Date (optional)",
                "Result Date (optional)",
            ],
            farm: "",
            task: "",
            toast: null,
        };
    },

    computed: {
        selectedLabFormat() {
            return (
                this.labFormats.find(
                    (format) => format.key === this.fileFormat
                ) || null
            );
        },

        farmerPlaceholderText() {
            if (Object.keys(this.farmer.farmers).length > 0) {
                return "Select Farmer...";
            }

            return "Search Farmer...";
        },
    },
    mounted() {
        this.toast = useToast();
    },
    created() {
        // this.getFarmers();
    },
    watch: {
        // Watch for changes in matchedHeader and add the selected value back to dropdownOptions if it's not in the options
        matchedHeader: {
            deep: true,
            handler() {},
        },
    },

    methods: {
        closeFarmer() {
            this.farmer.open = false;
        },

        optionSelected(index) {
            let vm = this;
            this.dropdownOptions.map((option) => {
                if (vm.matchedHeader.includes(option.value)) {
                    option.selected = true;
                } else {
                    option.selected = false;
                }
                return option;
            });
        },

        changeFile(e) {
            this.foundDuplicated = false;
            this.file = e.target.files[0];
        },

        csvHeadersHaveSomeValues(passCSVHeaders, passLiveFarmRequiredFields) {
            const csvHeaders = new Set(passCSVHeaders);
            const liveFarmRequiredFields = new Set(passLiveFarmRequiredFields);

            for (let value of csvHeaders) {
                if (liveFarmRequiredFields.has(value) && value != "Sample Id") {
                    return true; // Return true if at least one CSV header is found in required fields
                }
            }
            return false; // Return false if no CSV header is found in required fields
        },

        upload(e) {
            e.preventDefault();
            this.foundDuplicated = false;
            this.matchCsvHeader = false;
            this.awaitingConfirmation = false;

            // A lab's own file is checked on the server, which reports
            // missing columns and repeated samples in the error panel
            if (this.selectedLabFormat) {
                let data = new FormData();
                data.append("file", this.file);
                data.append("format", this.selectedLabFormat.key);
                this.sendFile(data);
                return;
            }

            //get the uploaded csv file check the headers if it match the required header
            let vm = this;

            Papa.parse(this.file, {
                header: true,
                skipEmptyLines: true,
                complete: function (results) {
                    const rowsArray = [];
                    let sampleId;
                    for (let i = 0; i < results.data.length; i++) {
                        const d = results.data[i];

                        /**
                         * Check if the csv is a livefarm formated csv
                         */
                        if (
                            vm.csvHeadersHaveSomeValues(
                                Object.keys(d),
                                vm.liveFarmRequiredFields
                            )
                        ) {
                            /**
                             * Check if the sample id is duplicated
                             */
                            sampleId = d["Sample Id"];
                            if (vm.hasDuplicate(results.data, "Sample Id")) {
                                console.log(`Duplicate found: ${sampleId}`);
                                vm.foundDuplicated = true;
                                break; // Stop the loop if a duplicate is found
                            }
                        }

                        //get the csv header once
                        if (rowsArray.length < 1) {
                            rowsArray.push(Object.keys(d));
                        }
                    }

                    // prevent the rest of the code from running if a duplicate is found
                    if (vm.foundDuplicated) {
                        vm.toast.error(
                            "Warning - there are duplicate sample IDs in this file. Please review and upload again."
                        );
                        return;
                    }
                    //check if all required column are set

                    /**
                     * ================================
                     * If this is livefarm formated csv
                     * ================================
                     */

                    //if any of the above header is set send the csv to back
                    if (
                        vm.csvHeadersHaveSomeValues(
                            rowsArray[0],
                            vm.liveFarmRequiredFields
                        )
                    ) {
                        let data = new FormData();
                        data.append("file", vm.file);

                        vm.sendFile(data);
                    } else {
                        /**
                         * ====================================
                         * If this is not livefarm formated csv
                         * ====================================
                         */

                        vm.matchCsvHeader = true;
                        //add none to the list
                        rowsArray[0].push("none");

                        vm.matchedHeader = vm.liveFarmRequiredFields.map(() => {
                            return "none";
                        });

                        vm.dropdownOptions = rowsArray[0].map((option) => {
                            return {
                                value: option,
                                selected: false,
                            };
                        });
                    }
                },
            });
        },

        /**
         * Post the file to the CSV import. A file that passes its checks is
         * staged, and the tasks found are shown for the user to confirm.
         */
        sendFile(data) {
            let existingObj = this;

            const config = {
                headers: {
                    "content-type": "multipart/form-data",
                },
            };

            axios
                .post(route("app.soil-analysis.csv-import.store"), data, config)
                .then(function (res) {
                    existingObj.success = null;
                    existingObj.errors = res.data.errors;
                    // Clear the previous upload's error panel
                    existingObj.error = false;
                    existingObj.error_type = null;
                    existingObj.download = res.data.download;
                    existingObj.importTasks = res.data.tasks;
                    existingObj.awaitingConfirmation = true;
                })
                .catch(function (err) {
                    existingObj.showRequestError(err);
                })
                .then(function () {
                    existingObj.matchCsvHeader = false;
                    existingObj.file = null;
                    document.getElementById("mobile").value = null;
                });
        },

        /**
         * Save the staged results now the user has confirmed the tasks found.
         */
        confirmUpload() {
            this.finishing = true;

            axios
                .post(
                    route(
                        "app.soil-analysis.csv-import.confirm",
                        this.download
                    )
                )
                .then((res) => {
                    this.showUploaded(res.data.tasks);
                })
                .catch((err) => {
                    this.showRequestError(err);
                })
                .finally(() => {
                    this.finishing = false;
                });
        },

        showUploaded(tasks) {
            this.success = true;
            this.importTasks = tasks;
            this.awaitingConfirmation = false;
            this.error = false;
            this.error_type = null;
            this.errors = [];
        },

        /**
         * Show why a request failed. With no response nothing is known about
         * the import, so the panel stays and the user can try again.
         */
        showRequestError(err) {
            if (!err.response) {
                this.toast.error(
                    "The server could not be reached. Please try again."
                );
                return;
            }

            // The file's problems, or results that reached its samples
            if (err.response.status == 422) {
                this.showImportError(err);
                return;
            }

            this.awaitingConfirmation = false;
            this.error = false;
            this.error_type = null;
            this.toast.error(
                err.response.data.message ||
                    "The CSV Import could not be finished. Please upload the file again."
            );
        },

        showImportError(err) {
            this.success = false;
            this.awaitingConfirmation = false;
            this.error = true;
            this.error_type = err.response.data.error;
            this.errors = err.response.data.errors;
            this.download = err.response.data.download;
            this.importTasks = err.response.data.tasks || [];

            // If we have a duplicate error, set "duplicated" to false so the checkboxes are un-checked
            if (this.error_type == "duplicated") {
                Object.keys(this.errors).forEach((key) => {
                    this.errors[key].duplicated = false;
                });
            }

            // If we have an sample id collusion
            if (this.error_type == "sample_id_collusion") {
                Object.keys(this.errors).forEach((key) => {
                    this.errors[key].collusion = false;
                });
            }
        },

        hasDuplicate(array, key) {
            const seen = new Set();
            for (let item of array) {
                if (seen.has(item[key])) {
                    return true;
                }
                seen.add(item[key]);
            }
            return false;
        },

        submitMapColumns() {
            const result = {};

            // Iterate over array1 and use each value as a key to access the corresponding value from array2
            this.liveFarmBackendFields.forEach((key, index) => {
                result[key] = this.matchedHeader[index];
            });

            Papa.parse(this.file, {
                header: true,
                skipEmptyLines: true,
                complete: (results) => {
                    if (this.hasDuplicate(results.data, result["sample_id"])) {
                        this.foundDuplicated = true;
                        this.toast.error(
                            "Warning - there are duplicate sample IDs in this file. Please review and upload again."
                        );
                        return;
                    }

                    let data = new FormData();
                    data.append("file", this.file);
                    data.append("headers", JSON.stringify(result));

                    this.sendFile(data);
                },
            });
        },

        duplicated(e) {
            this.finishing = true;

            axios
                .post(
                    route(
                        "app.soil-analysis.csv-import.duplicated",
                        this.download
                    ),
                    this.errors
                )
                .then((res) => {
                    this.showUploaded(res.data.tasks);
                })
                .catch((err) => {
                    this.showRequestError(err);
                })
                .finally(() => {
                    this.finishing = false;
                });
        },

        // TODO: Implement collusion handling - route and controller method missing
        /*
        // TODO: Implement collusion handling - route and controller method missing
        /*
        collusion(e) {
            axios
                .post(
                    route(
                        "app.soil-analysis.csv-import.collusion",
                        this.download
                    ),
                    this.errors
                )
                .then(function (res) {
                    window.location.href = route(
                        "app.task.index"
                    );
                });
        },
        */
    },
};
</script>

<style src="@vueform/multiselect/themes/default.css"></style>
